<template>
  <div class="filters__dropdown-wrapper">
    <label class="utility-flex" for="multiselect">Districts:</label>
    <div>
      <multiselect
        label="Name"
        placeholder="All districts"
        @input="selectSubRegions"
        @keypress="selectSubRegions"
        :disabled="disableSubRegionDropdown"
        :hide-selected="true"
        :multiple="true"
        :options="subRegionsForRegion"
        :searchable="false"
        :showLabels= "false"
        :tabIndex="0"
        :value="selectedSubregions"
      ></multiselect>

      <div class="region__tag-wrapper">
        <div
          class="region__tag"
          :class="{ 'is-tab2': isTab2}"
          v-for="subRegion in $store.state.selectedSubRegions"
          :key="subRegion.ID"
        >
          <div
            tabindex="0"
            name="subregion.Name"
            class="region__tag-content"
            @click="removeSubRegions(subRegion.ID, subRegion.Name)"
            @keypress="removeSubRegions(subRegion.ID, subRegion.Name)"
            :data-id="subRegion.ID"
          >
            {{ subRegion.Name }}
            <span class="icon icon-close-circle-right"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Multiselect from "vue-multiselect";

export default Vue.component("FiltersSubregion", {
  props: {
    deleteSubRegions: Function,
    disableSubRegionDropdown: Boolean,
    selectedSubregions: Array,
    subRegionsForRegion: Array,
    isTab2: Boolean,
    updateSubRegions: Function,
  },
  components: {
    Multiselect,
  },
  methods: {
    selectSubRegions: function (event) {
      this.updateSubRegions({ ID: event[0].ID, Name: event[0].Name });
    },
    removeSubRegions: function (id, name) {
      this.deleteSubRegions({ ID: id, Name: name });
    }
  },
});
</script>